const maritalStatus = [
    "Soltero/a",
    "Casado/a",
    "Divorciado/a",
    "Viudo/a",
    "Unión libre",
  ];
  
  export default maritalStatus;
  